import {MenuTextMatch,} from '@lexical/react/LexicalTypeaheadMenuPlugin'
import {AtSignMentionsRegex, AtSignMentionsRegexAliasRegex, CapitalizedNameMentionsRegex} from "../constants/constants";

function checkForCapitalizedNameMentions(
    text: string,
    minMatchLength: number,
): MenuTextMatch | null {
    const match = CapitalizedNameMentionsRegex.exec(text);
    if (match !== null) {
        // The strategy ignores leading whitespace but we need to know it's
        // length to add it to the leadOffset
        const maybeLeadingWhitespace = match[1];

        const matchingString = match[2];
        if (matchingString != null && matchingString.length >= minMatchLength) {
            return {
                leadOffset: match.index + (maybeLeadingWhitespace ? maybeLeadingWhitespace.length : 0),
                matchingString,
                replaceableString: matchingString,
            };
        }
    }
    return null;
}

function checkForAtSignMentions(
    text: string,
    minMatchLength: number,
): MenuTextMatch | null {
    let match = AtSignMentionsRegex.exec(text);

    if (match === null) {
        match = AtSignMentionsRegexAliasRegex.exec(text);
    }
    if (match !== null) {
        // The strategy ignores leading whitespace but we need to know it's
        // length to add it to the leadOffset
        const maybeLeadingWhitespace = match[1];

        const matchingString = match[3];
        if (matchingString.length >= minMatchLength) {
            return {
                leadOffset: match.index + (maybeLeadingWhitespace ? maybeLeadingWhitespace.length : 0),
                matchingString,
                replaceableString: match[2],
            };
        }
    }
    return null;
}

export function getPossibleQueryMatch(text: string): MenuTextMatch | null {
    let match           = checkForAtSignMentions(text, 0)
    // if (!match) match   = checkForCapitalizedNameMentions(text, 2)
    return match
}
